// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router instance
import './input.css'

const app = createApp(App);

app.use(router).mount('#app');
